export const DEFAULT_TTS_LOCALE = "zh-CN";

const TTS_LOCALE_PATTERN = /^[A-Za-z]{2,3}(?:-[A-Za-z]{2,8})+$/;

export function isValidTtsLocale(value: unknown): value is string {
  return (
    typeof value === "string" &&
    value.length <= 35 &&
    TTS_LOCALE_PATTERN.test(value)
  );
}
